import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { RiMenu3Fill } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { Link as RouterLink, useNavigate } from "react-router-dom";

const NavigationSection = ({ setIsMenuOpen }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [bgColor, setBgColor] = useState("bg-transparent");
  const [marginT, setMarginT] = useState("mt-[6vmin]");
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setIsMenuOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "auto";
  };

  const handleScrollToSection = (sectionId) => {
    // Close the mobile menu
    setIsOpen(false);
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";

    navigate("/"); // Navigate to the main page

    // Scroll to the section after navigating
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); 
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.1;

      if (window.scrollY > scrollThreshold) {
        setBgColor("bg-white bg-opacity-85 backdrop-blur-lg");
        setMarginT("mt-[3vmin]");

        const securityText = document.getElementById("security_text");
        const codeText = document.getElementById("code_text");
        const logo = document.getElementById("logo");
        const hambMenu = document.getElementById("hamb_menu");

        if (securityText) securityText.style.color = "#0066FF";
        if (codeText) codeText.style.color = "#0066FF";
        if (logo) logo.classList.add('gradient-animation');
        if (hambMenu) hambMenu.style.color = "#0066FF";

        document.querySelectorAll(".text-white .text-1xl").forEach(element => {
          element.style.color = "#000000"; 
          element.addEventListener("mouseover", function() {
            element.style.color = "#00FF00";
          });
          element.addEventListener("mouseout", function() {
            element.style.color = "#000000";
          });
        });



      } else {
        setBgColor("bg-transparent");
        setMarginT("mt-[6vmin]");

        const securityText = document.getElementById("security_text");
        const codeText = document.getElementById("code_text");
        const logo = document.getElementById("logo");
        const hambMenu = document.getElementById("hamb_menu");

        if (securityText) securityText.style.color = "#FFFFFF";
        if (codeText) codeText.style.color = "#FFFFFF";
        if (logo) logo.classList.remove('gradient-animation');
        if (hambMenu) hambMenu.style.color = "#00FF00";

        document.querySelectorAll(".text-white .text-1xl").forEach(element => {
          element.style.color = "#FFFFFF"; 
          element.addEventListener("mouseover", function() {
            element.style.color = "#00FF00";
          });
          element.addEventListener("mouseout", function() {
            element.style.color = "#FFFFFF";
          });
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`${bgColor} fixed w-full top-0 left-0 z-50 transition duration-300 ease-in-out`}>
      <div className="flex items-center px-0 py-0 text-white w-full">
        {/* Logo Section */}
        <div className={`flex items-center mx-[4.5vmin] md:mx-[2.25vmin] lg:mx-[7.5vw] my-[7vmin] md:my-7 lg:${marginT}`} id="logo_section">
          <a href="/" className="focus:outline-none" id="logo_svg">
            <Logo />
          </a>
          <span className="text-[5vmin] md:text-[32px] lg:text-[4vmin] font-bold ml-2">
            <span id="security_text">Security</span>
            <span id="code_text">Code</span>
          </span>
        </div>

        {/* Menu Items for Larger Screens */}
        <div className={`hidden md:flex ml-auto space-x-8 mx-5 md:mr-[8vw] items-center lg:${marginT}`} id="navigation_elements">
          <button
            className="font-normal transition duration-300 text-1xl lg:text-[2vmin] cursor-pointer"
            onClick={() => handleScrollToSection("what-we-do")}
          >
            {t("navigation.services")}
          </button>
          <button
            className="font-normal transition duration-300 text-1xl lg:text-[2vmin] cursor-pointer"
            onClick={() => handleScrollToSection("projects")}
          >
            {t("navigation.portfolio")}
          </button>
          {/* <RouterLink
            to="/about"
            className="font-normal transition duration-300 text-1xl"
          >
            {t("navigation.about_us")}
          </RouterLink> */}
        </div>

        {/* Hamburger Icon for Small Screens */}
        <div className="md:hidden flex items-center ml-auto mr-[3vw]">
          <button
            onClick={toggleMenu}
            className="focus:outline-none"
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? (
              <span className="text-[8vmin] text-gray-500 fixed top-[6vmin] right-[3vmin] z-[60] transition-transform transform duration-300 ease-in-out">
                <IoMdClose style={{ color: "#0066FF" }} />
              </span>
            ) : (
              <span className="text-[8vmin] text-gray-500 transition-transform transform duration-300 ease-in-out">
                <RiMenu3Fill style={{ color: "#00FF00" }} />
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white shadow-lg py-[14vmin] fixed top-0 left-0 w-full transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-y-0" : "-translate-y-full"
        }`}
        style={{ zIndex: 50 }}
      >
        <button
          className="block py-2 px-4 text-gray-600 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleScrollToSection("what-we-do")}
        >
          {t("navigation.services")}
        </button>
        <button
          className="block py-2 px-4 text-gray-600 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleScrollToSection("projects")}
        >
          {t("navigation.portfolio")}
        </button>
        {/* <RouterLink
          to="/about"
          className="block py-2 px-4 text-gray-600 hover:bg-gray-100"
          onClick={toggleMenu}
        >
          {t("navigation.about_us")}
        </RouterLink> */}
      </div>
    </nav>
  );
};

export default NavigationSection;
